import {ApiError} from "@variocube/app-ui";

export async function ignoreNotFound<T>(fn: () => Promise<T>): Promise<T | undefined> {
	try {
		return await fn();
	} catch (e) {
		if (e instanceof ApiError && e.status === 404) {
			return undefined;
		}
		throw e;
	}
}
